module.exports = __webpack_public_path__ + "static/zen-in-the-art-of-writing-00fe9dbf8e789cf819b6a7c2266332d8.jpg";